var MENU_BALANCE_LOAD_SUCCESS = 'MENU_BALANCE_LOAD_SUCCESS';
var MENU_BALANCE_LOAD_URL = '/common/menu/balance';
var REDUCER_MENU_BALANCE_NAME = 'menuBalance';
export { MENU_BALANCE_LOAD_SUCCESS, MENU_BALANCE_LOAD_URL, REDUCER_MENU_BALANCE_NAME };